/**
 * The `↵` affordance, drawn rather than typed (日本-500, shared by 日本-501).
 *
 * **Both halves of "drawn, not typed" are load-bearing.** U+21B5 was wrong three ways at once on
 * the landing and only the colour was noticed: the glyph carried **6px of ink against a 20px
 * label** and sat **1.3px low** — 22% of its own height — and neither is reachable from CSS. Weight
 * and position are set here instead, and the mark inherits `currentColor`, so a call site sets one
 * colour and the disabled `opacity-40` carries the arrow with it.
 *
 * **The vertical offset is CALIBRATED per call site and is deliberately a prop.** It is not a
 * property of the mark: it depends on the label beside it, and two formulas were tried against
 * Alex's eye and both failed — matching the arrow's ink centroid to the label's read LOW, and
 * matching its ink bounding box read HIGH. Each value came from a rendered ladder judged by eye.
 * **Do not replace either one with a computation**, and do not reuse one site's value at another
 * label size without re-judging it.
 *
 * The geometry — 18×17 on a 17×16 viewBox, 2px round-capped stroke — is the part that IS shared,
 * and having it in one file is the point: this was the third instance of one affordance drawn three
 * different ways.
 */
export function EnterKey({
  className = "",
  offsetPx,
  check,
}: {
  /** Colour, via `currentColor`. Everything else about the mark is fixed. */
  className?: string;
  /** The calibrated vertical nudge for THIS label, in px. See above — never a formula. */
  offsetPx: number;
  /** `checks/` hook. The browser checks measure the mark's ink; `npm test` has no DOM. */
  check: string;
}) {
  return (
    <svg
      aria-hidden
      data-check={check}
      width="18"
      height="17"
      viewBox="0 0 17 16"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      className={`shrink-0 ${className}`}
      style={{ transform: `translateY(${offsetPx}px)` }}
    >
      <path d="M14 4 V9 H3" />
      <path d="M7 5 L3 9 L7 13" />
    </svg>
  );
}
